import DatePicker, { registerLocale } from "react-datepicker";
// eslint-disable-next-line import-x/no-duplicates
import { getYear, getMonth } from "date-fns";
// eslint-disable-next-line import-x/no-duplicates
import { fr } from "date-fns/locale";
import { FieldError } from "react-hook-form";
import DateInput from "./DateInput";
import { MONTHS, YEARS } from "../Utils/DatePicker";
import "react-datepicker/dist/react-datepicker.css";

import { useStyles } from "./BataillogDatePicker.styles";

registerLocale("fr", fr);

// react-datepicker v8 types selectsRange as a discriminated union requiring
// a literal `true`, which doesn't model this component's runtime toggle
// between single-date and range mode.
const AnyDatePicker = DatePicker as any;

function BataillogDatePicker({
  selectedDate,
  startDate,
  endDate,
  minDate,
  onDateChange,
  onCalendarClose,
  label,
  error,
  variant,
  displayCalendarIcon = true,
  style,
  selectsRange = false,
  disabled = false,
  isClearable = true,
  inline = false,
  popperProps = { strategy: "fixed" },
}: {
  selectedDate?: Date;
  startDate?: Date | null;
  endDate?: Date | null;
  minDate?: Date | null;
  onDateChange: (dates: Date | null | [Date | null, Date | null]) => void;
  onCalendarClose?: (dates: [Date | null, Date | null]) => void;
  label?: string;
  error?: boolean | FieldError;
  variant?: "outlined" | "standard" | "filled" | undefined;
  displayCalendarIcon?: boolean;
  style?: any;
  selectsRange?: boolean;
  disabled?: boolean;
  isClearable?: boolean;
  /** Renders the calendar inline (no Floating-UI popup). Useful in tests. */
  inline?: boolean;
  popperProps?: any;
}) {
  const classes = useStyles();
  const renderCustomHeader = ({
    date,
    changeYear,
    changeMonth,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
  }) => {
    const navigateToToday = () => {
      const today = new Date();
      changeYear(getYear(today));
      changeMonth(getMonth(today));
    };

    return (
      <div
        style={{
          margin: 10,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <button
          type="button"
          onClick={navigateToToday}
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: "#457DD9",
            color: "white",
            padding: "5px",
            border: "none",
            cursor: "pointer",
          }}
        >
          Aujourd&apos;hui
        </button>
        <button
          type="button"
          onClick={decreaseMonth}
          disabled={prevMonthButtonDisabled}
        >
          {"<"}
        </button>
        <select
          value={getYear(date)}
          onChange={({ target: { value } }) => changeYear(parseInt(value, 10))}
        >
          {YEARS.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
        <select
          value={MONTHS[getMonth(date)]}
          onChange={({ target: { value } }) =>
            changeMonth(MONTHS.indexOf(value))
          }
        >
          {MONTHS.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
        <button
          type="button"
          onClick={increaseMonth}
          disabled={nextMonthButtonDisabled}
        >
          {">"}
        </button>
      </div>
    );
  };

  const propsDate = {} as { selected: Date; startDate?: Date; endDate?: Date };
  propsDate.selected = selectedDate ? new Date(selectedDate) : null;
  if (selectsRange) {
    propsDate.startDate = startDate ? new Date(startDate) : null;
    propsDate.endDate = endDate ? new Date(endDate) : null;
  }

  return (
    <AnyDatePicker
      locale="fr"
      renderCustomHeader={renderCustomHeader}
      disabled={disabled}
      inline={inline}
      {...propsDate}
      minDate={minDate}
      className={classes.default}
      onChange={onDateChange}
      onCalendarClose={() => {
        if (onCalendarClose && selectsRange) {
          onCalendarClose([startDate ?? null, endDate ?? null]);
        }
      }}
      selectsRange={selectsRange}
      dateFormat="dd/MM/yyyy"
      strictParsing
      popperProps={popperProps}
      popperClassName={classes.popClass}
      isClearable={isClearable}
      customInput={
        <DateInput
          startDate={startDate ?? selectedDate}
          error={!!error}
          endDate={endDate}
          label={label}
          variant={variant}
          style={style}
          displayCalendarIcon={displayCalendarIcon}
          onClear={() => onDateChange(selectsRange ? [null, null] : null)}
        />
      }
    />
  );
}

export default BataillogDatePicker;
